import React from "react";
import {
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel, OverlayTrigger
} from "react-bootstrap";
// react component that creates a dropdown menu for selection
import "react-select/dist/react-select.css";
// react component that creates a dropdown menu for selecting a date
import Datetime from "react-datetime";
import Card from "../../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';

import Button from "../../../components/CustomButton/CustomButton.jsx";
import ReactDOM from 'react-dom';
import SignatureCanvas from 'react-signature-canvas'
import Camera from 'react-camera';
import Webcam from "react-webcam";
import PropTypes from "prop-types";
import rest from "../../../API/api";
import sha1 from "sha1";

class Personal_Step3 extends React.Component {
  constructor(props) {
    super(props);
    this._grabUserInput = this._grabUserInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearConsentSignature = this.clearConsentSignature.bind(this);
    this.clearGuardianConsentSignature = this.clearGuardianConsentSignature.bind(this);
    this.getAge = this.getAge.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.takePicture = this.takePicture.bind(this);
    this.saveConsentSubmission = this.saveConsentSubmission.bind(this);

    //this.getage = this.getage.bind(this);
    this.state = {
      consentName: props.getStore().consentName,
      consentAddress: props.getStore().consentAddress,
      consentPhone: props.getStore().consentPhone,
      consentEmail: props.getStore().consentEmail,
      consentNationality: props.getStore().consentNationality,
      consentGender: props.getStore().consentGender,
      consentDoB: props.getStore().consentDoB,
      consentAge: props.getStore().consentAge,
      consentOldEnough: props.getStore().consentOldEnough,
      consentParentConsentNeeded: props.getStore().consentOldEnough,
      consentSignature:  props.getStore().consentSignature,
      consentGuardianName: props.getStore().consentGuardianName,
      consentGuardianSignature: props.getStore().consentGuardianSignature,
      consentGuardianRelation: props.getStore().consentGuardianRelation,
      consentClauses: props.getStore().consentClauses,
      consentClausesStatus: props.getStore().consentClausesStatus,
      consentPhotoId:props.getStore().consentPhotoId,
      consentDate:props.getStore().consentDate,
      consentArtist:props.getStore().consentArtist,
      consentNotes: props.getStore().consentNotes,
      consentFooter: props.getStore().consentFooter,
      submitButton: false,
      consentNameError: null,
      consentAddressError: null,
      consentPhoneError: null,
      consentEmailError: null,
      consentNationalityError: null,
      consentGenderError: null,
      consentDoBError: null,
      consentAgeError: null,
      consentSignatureError: null,
      consentGuardianNameError: null,
      consentGuardianRelationError: null,
      consentGuardianSignatureError: null,
      consentNotesError: null
    };
  }

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    successAlert(saved){
        //Setup the alert and use the context to route to the Tenants once record is saved.
        if(saved) {
            //Lets clear out the submission for the next go
            this.props.consentSubmission.consentClausesStatus.map((e, key) => {
                this.props.consentSubmission.consentClausesStatus[key].checked = false;
            });
            var consentSubmission = {
                //These are the fields that I need to store for the consent submission not the consent form settings
                consentDate: "",
                consentArtist: "",
                consentClauses: [],
                consentClausesStatus: [],
                consentName: "",
                consentAddress: "",
                consentPhone: "",
                consentEmail: "",
                consentNationality: "",
                consentGender: "",
                consentDoB: "",
                consentPhotoId:"",
                consentAge: "",
                consentOldEnough: false,
                consentParentConsentNeeded: false,
                consentSignature:  "",
                consentGuardianName: "",
                consentGuardianRelation: "",
                consentGuardianSignature: "",
                consentNotes: "",
                consentFooter: "",
                savedConsent: false,
            };
            this.props.updateStore(consentSubmission);
            //Setup the alert and use the context to route to the Tenants once record is saved.
            //Lets erase this submissions data from the store incase we need to start the wizard over.
            if(this.props.consentSubmission.AfterSubmit === "Same") {
                this.setState({
                    alert: (
                        <SweetAlert
                            success
                            title="Your Consent Submission was saved successfully!"
                            style={{display: "block"}}
                            onConfirm={() => this.props.jumpToStep(0)}
                            onCancel={() => this.props.jumpToStep(0)}
                            confirmBtnBsStyle="info"
                        >
                        </SweetAlert>
                    )
                });
            }
            else if ((this.props.consentSubmission.AfterSubmit === "Index") && (this.props.userRole !== "Kiosk") ) {
                this.setState({
                    alert: (
                        <SweetAlert
                            success
                            title="Your Consent Submission was saved successfully!"
                            style={{display: "block"}}
                            onConfirm={() => this.context.router.history.push("/consents")}
                            onCancel={() => this.context.router.history.push("/consents")}
                            confirmBtnBsStyle="info"
                        >
                        </SweetAlert>
                    )
                });
            }
            else {
                this.setState({
                    alert: (
                        <SweetAlert
                            success
                            title="Your Consent Submission was saved successfully!"
                            style={{display: "block"}}
                            onConfirm={() => this.context.router.history.push("/kioskmode")}
                            onCancel={() => this.context.router.history.push("/kioskmode")}
                            confirmBtnBsStyle="info"
                        >
                        </SweetAlert>
                    )
                });

            }
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Missing required fields, please correct field values and try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    _grabUserInput() {
        //debugger;
        var myconsentName = "";
        var myconsentAddress= "";
        var myconsentPhone = "";
        var myconsentEmail= "";
        var myconsentNationality = "";
        var myconsentGender= "";
        var myconsentSignature="";
        var myconsentParentName = "";
        var myconsentParentRelation = "";
        var myconsentParentSignature = "";
        var myconsentClauses =[];

        if (this.props.consentSubmission.RequireName)
            myconsentName = document.getElementById('consentName').value;
        if (this.props.consentSubmission.RequireAddress)
            myconsentAddress = document.getElementById('consentAddress').value;
        if (this.props.consentSubmission.RequirePhone)
            myconsentPhone = document.getElementById('consentPhone').value;
        if (this.props.consentSubmission.RequireEmail)
            myconsentEmail = document.getElementById('consentEmail').value;
        if (this.props.consentSubmission.RequireNationality)
            myconsentNationality = document.getElementById('consentNationality').value;
        if (this.props.consentSubmission.RequireGender)
            myconsentGender = document.getElementById('consentGender').value;
        if(!this.sigCanvas.isEmpty())
            myconsentSignature = this.sigCanvas.toDataURL();
        if(this.state.consentParentConsentNeeded) {
            myconsentParentName = document.getElementById('consentGuardianName').value;
            if(this.props.consentSubmission.AskRelation)
                myconsentParentRelation = document.getElementById('consentGuardianRelation').value;
            if(!this.sigGuardianCanvas.isEmpty())
              myconsentParentSignature = this.sigGuardianCanvas.toDataURL();
        }
        //Lets update the consentClauses for the submission database record
        this.props.consentSubmission.IncludedClauses.map((e, key) => {
            myconsentClauses.push({
                Title: e.Title,
                Clause: e.Text,
                Type: e.Type,
                Required: e.Required,
                Acknowledged: this.props.consentSubmission.consentClausesStatus[key].checked
            });
        });

        return {

            consentName: myconsentName,
            consentDoB: this.state.consentDoB,
            consentAge: this.state.consentAge,
            consentAddress: myconsentAddress,
            consentPhone: myconsentPhone,
            consentEmail:  myconsentEmail,
            consentNationality:  myconsentNationality,
            consentGender:  myconsentGender,
            consentSignature: myconsentSignature,
            consentGuardianName: myconsentParentName,
            consentGuardianRelation: myconsentParentRelation,
            consentGuardianSignature: myconsentParentSignature,
            consentPhotoId: this.state.consentPhotoId,
            consentClauses: myconsentClauses,
            consentNotes: document.getElementById('consentNotes').value,
            consentFooter: this.props.consentSubmission.ConsentFooter,
            consentFormName: this.props.consentSubmission.Name
        };

    }

    isValidated(userInput) {
      //debugger;
      //const userInput = this._grabUserInput(); // grab user entered vals

      //Lets run throught the Clauses Array and see if its a required clause, is so then cross reference the element in
      //the Status array using the index and store the results, returning valid if they acknowledged all the required
      //clauses

      var valid = true;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //If required from consent form settings, validate
        var name = true;
        if(this.props.consentSubmission.RequireName) {
            (this.state.consentName === "")
                ? this.setState({
                    consentNameError: (
                        <small className="text-danger">
                            Please provide your full name.
                        </small>
                    )
                })
                : this.setState({consentNameError: null});
            name = (this.state.consentName !== "");
        }

        //If required from consent form settings, validate

        //(this.state.consentDoB === "")
        (!this.isValidDate(this.state.consentDoB))
            ? this.setState({
                consentDoBError: (
                    <small className="text-danger">
                        Please provide your Date of Birth in the format mm/dd/yyyy
                    </small>
                )
            })
            : this.setState({consentDoBError: null});
        var dateofbirth = this.isValidDate(this.state.consentDoB);
        //var dateofbirth = (this.state.consentDoB !== "");



        //If required from consent form settings, validate
        var address = true;
        if(this.props.consentSubmission.RequireAddress) {
            (this.state.consentAddress === "")
                ? this.setState({
                    consentAddressError: (
                        <small className="text-danger">
                            Please provide your full address.
                        </small>
                    )
                })
                : this.setState({consentAddressError: null});
            address = (this.state.consentAddress !== "");
        }

        //If required from consent form settings, validate
        var phone = true;
        if(this.props.consentSubmission.RequirePhone) {
            (this.state.consentPhone === "")
                ? this.setState({
                    consentPhoneError: (
                        <small className="text-danger">
                            Please provide your phone number.
                        </small>
                    )
                })
                : this.setState({consentPhoneError: null});
            phone = (this.state.consentPhone !== "");
        }
        var email = true;
        if(this.props.consentSubmission.RequireEmail) {
            re.test(this.state.consentEmail) === false
                ? this.setState({
                    consentEmailError: (
                        <small className="text-danger">
                            Your email address is required and format should be <i>john@doe.com</i>.
                        </small>
                    )
                })
                : this.setState({consentEmailError: null});
            email = re.test(this.state.consentEmail);
        }

        //If required from consent form settings, validate
        var nationality = true;
        if(this.props.consentSubmission.RequireNationality) {
            (this.state.consentNationality === "")
                ? this.setState({
                    consentNationalityError: (
                        <small className="text-danger">
                            Please provide your nationality.
                        </small>
                    )
                })
                : this.setState({consentNationalityError: null});
            nationality = (this.state.consentNationality !== "");
        }

        //If required from consent form settings, validate
        var gender = true;
        if(this.props.consentSubmission.RequireGender) {
            (this.state.consentGender === "")
                ? this.setState({
                    consentGenderError: (
                        <small className="text-danger">
                            Please provide your gender.
                        </small>
                    )
                })
                : this.setState({consentGenderError: null});
            gender= (this.state.consentGender !== "");
        }
        (userInput.consentSignature === "")
            ? this.setState({
                consentSignatureError: (
                    <small className="text-danger">
                        Please provide your signature.
                    </small>
                )
            })
            : this.setState({consentSignatureError: null});
        var signature = (userInput.consentSignature !== "");

        var parent_guardian = true;
        var parent_guardian_relation = true;
        var parent_signature = true;

        if(this.state.consentParentConsentNeeded) {
            (this.state.consentGuardianName === "")
                ? this.setState({
                    consentGuardianNameError: (
                        <small className="text-danger">
                            Please provide your Parent / Guardian's name.
                        </small>
                    )
                })
                : this.setState({consentGuardianNameError: null});
            parent_guardian = (this.state.consentGuardianName !== "");

            if(this.props.consentSubmission.AskRelation){
                (this.state.consentGuardianRelation === "")
                    ? this.setState({
                        consentGuardianRelationError: (
                            <small className="text-danger">
                                Please provide your relation to your Parent / Guardian
                            </small>
                        )
                    })
                    : this.setState({consentGuardianRelationError: null});
                parent_guardian_relation = (this.state.consentGuardianRelation !== "");

            }

            (userInput.consentGuardianSignature === "")
                ? this.setState({
                    consentGuardianSignatureError: (
                        <small className="text-danger">
                            Please provide your Parent / Guardian's signature.
                        </small>
                    )
                })
                : this.setState({consentGuardianSignatureError: null});
            parent_signature = (userInput.consentGuardianSignature !== "");

        }

        (userInput.consentPhotoId === "")
            ? this.setState({
                consentPhotoIdError: (
                    <small className="text-danger">
                        Please provide a photo of your government issued ID.
                    </small>
                )
            })
            : this.setState({consentPhotoIdError: null});
        var photo = (this.state.consentPhotoId !== "");


        (this.state.consentNotes === "")
            ? this.setState({
                consentNotesError: (
                    <small className="text-danger">
                        Please complete the notes section with important Health Dept. Information.
                    </small>
                )
            })
            : this.setState({consentNotesError: null});
        var notes = (this.state.consentNotes !== "");

        valid = (name && notes && dateofbirth && address && phone && email && nationality && gender && signature && parent_guardian && parent_guardian_relation && parent_signature && photo);


      /*
      this.props.consentSubmission.IncludedClauses.map((e, key) => {
          if (e.Required === "Required") {
              if (this.props.consentSubmission.consentClausesStatus[key].checked === false) {
                  valid = false;
              }
          }
      });
          if(valid)
              this.props.updateStore({
                  ...userInput,
                  savedConsent: false // use this to notify step4 that some changes took place and prompt the user to save again
              });
          else
              this.failedAlert();
*/
          return valid;
  }

    saveConsentSubmission(event) {
        event.preventDefault();

        let userInput = this._grabUserInput();
        if (this.isValidated(userInput)) {
            this.setState({submitButton: false});
            //Makes an API call to the gateway which will add the consent under the tenant _id. API call
            //will return the current set of records after the deletion so we will dispatch a store update with the new records.
            const cloudURL = this.props.tenant.cloudinary_upload;
            //Build some const. for signing the payload
            const timestamp = Date.now();
            const api_key = this.props.tenant.apiKeyCloudinary;
            const api_secret = this.props.tenant.apiSecretKeyCloudinary;
            var myPhotoId_s = "";
            var myPhotoIdPublicId_s = "";
            let mySignature_s = "";
            let mySignaturePublicId_s = "";
            let myGuardianSignature_s = "";
            let myGuardianSignaturePublicId_s = "";
            let myUserId_s = this.props.userId;

            var crypto = require('crypto');
            //assign the Salt, generate the hash based on the password provided
            let mySalt = crypto.randomBytes(16).toString('hex');
            let myHash = crypto.pbkdf2Sync(myUserId_s, mySalt, 1000, 16, 'sha512').toString('hex');
            //Ok lets add the photo ID first to Cloudinary
            if (userInput.consentPhotoId !== "") {
                let payload_to_sign = "public_id=" + myHash + "_ID" + "&timestamp=" + timestamp + "&upload_preset=y8vyt0bt" + api_secret;
                let sha1_hash = sha1(payload_to_sign);
                fetch(cloudURL, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json;charset=UTF-8',
                    }),
                    body: JSON.stringify({
                        api_key: api_key,
                        file: userInput.consentPhotoId,
                        public_id: myHash + "_ID",
                        signature: sha1_hash,
                        timestamp: timestamp,
                        //this is the preset key for the directory I have setup in Cloudinary
                        upload_preset: "y8vyt0bt"
                    }),
                })
                    .then(response => response.json())
                    .then(data => {
                        myPhotoId_s = data.secure_url;
                        myPhotoIdPublicId_s = data.public_id;
                        if (userInput.consentSignature !== "") {
                            let payload_to_sign = "public_id=" + myHash + "_SIG" + "&timestamp=" + timestamp + "&upload_preset=y8vyt0bt" + api_secret;
                            let sha1_hash = sha1(payload_to_sign);
                            fetch(cloudURL, {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json;charset=UTF-8',
                                }),
                                body: JSON.stringify({
                                    api_key: api_key,
                                    file: userInput.consentSignature,
                                    public_id: myHash + "_SIG",
                                    signature: sha1_hash,
                                    timestamp: timestamp,
                                    //this is the preset key for the directory I have setup in Cloudinary
                                    upload_preset: "y8vyt0bt"
                                }),
                            })
                                .then(response => response.json())
                                .then(data => {
                                    mySignature_s = data.secure_url;
                                    mySignaturePublicId_s = data.public_id;
                                    //Now lets store the Guardian Signature if one exists
                                    if (userInput.consentGuardianSignature !== "") {
                                        let payload_to_sign = "public_id=" + myHash + "_GUARDIANSIG" + "&timestamp=" + timestamp + "&upload_preset=y8vyt0bt" + api_secret;
                                        let sha1_hash = sha1(payload_to_sign);
                                        fetch(cloudURL, {
                                            method: 'POST',
                                            headers: new Headers({
                                                'Content-Type': 'application/json;charset=UTF-8',
                                            }),
                                            body: JSON.stringify({
                                                api_key: api_key,
                                                file: userInput.consentGuardianSignature,
                                                public_id: myHash + "_GUARDIANSIG",
                                                signature: sha1_hash,
                                                timestamp: timestamp,
                                                //this is the preset key for the directory I have setup in Cloudinary
                                                upload_preset: "y8vyt0bt"
                                            }),
                                        })
                                            .then(response => response.json())
                                            .then(data => {
                                                myGuardianSignature_s = data.secure_url;
                                                myGuardianSignaturePublicId_s = data.public_id;
                                                let tempURL = rest.submissions;
                                                fetch(tempURL, {
                                                    method: 'POST',
                                                    headers: new Headers({
                                                        'Content-Type': 'application/json;charset=UTF-8',
                                                        'x-api-key': this.props.tenant.apiKey
                                                    }),
                                                    body: JSON.stringify({
                                                        TenantId: myUserId_s,
                                                        ConsentId: this.props.consentSubmission._id,
                                                        Date: this.state.consentDate,
                                                        Artist: this.state.consentArtist,
                                                        ConsentName: userInput.consentName,
                                                        ConsentAddress: userInput.consentAddress,
                                                        ConsentPhone: userInput.consentPhone,
                                                        ConsentEmail: userInput.consentEmail,
                                                        ConsentNationality: userInput.consentNationality,
                                                        ConsentGender: userInput.consentGender,
                                                        ConsentDOB: userInput.consentDoB,
                                                        ConsentAge: userInput.consentAge,
                                                        ConsentPhotoId: myPhotoId_s,
                                                        ConsentPhotoIdPublicId: myPhotoIdPublicId_s,
                                                        ConsentSignature: mySignature_s,
                                                        ConsentSignaturePublicId: mySignaturePublicId_s,
                                                        ConsentGuardianName: userInput.consentGuardianName,
                                                        ConsentGuardianRelation: userInput.consentGuardianRelation,
                                                        ConsentGuardianSignature: myGuardianSignature_s,
                                                        ConsentGuardianSignaturePublicId: myGuardianSignaturePublicId_s,
                                                        ConsentClauses: userInput.consentClauses,
                                                        ConsentNotes: userInput.consentNotes,
                                                        ConsentFooter: userInput.consentFooter,
                                                        ConsentFormName: userInput.consentFormName
                                                    }),
                                                })
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        //console.log(data);
                                                    })
                                                    .catch(error => console.error(error));
                                                this.successAlert(true);
                                            })
                                            .catch(error => console.error(error));
                                    }
                                    else {
                                        let tempURL = rest.submissions;
                                        fetch(tempURL, {
                                            method: 'POST',
                                            headers: new Headers({
                                                'Content-Type': 'application/json;charset=UTF-8',
                                                'x-api-key': this.props.tenant.apiKey
                                            }),
                                            body: JSON.stringify({
                                                TenantId: myUserId_s,
                                                ConsentId: this.props.consentSubmission._id,
                                                Date: this.state.consentDate,
                                                Artist: this.state.consentArtist,
                                                ConsentName: userInput.consentName,
                                                ConsentAddress: userInput.consentAddress,
                                                ConsentPhone: userInput.consentPhone,
                                                ConsentEmail: userInput.consentEmail,
                                                ConsentNationality: userInput.consentNationality,
                                                ConsentGender: userInput.consentGender,
                                                ConsentDOB: userInput.consentDoB,
                                                ConsentAge: userInput.consentAge,
                                                ConsentPhotoId: myPhotoId_s,
                                                ConsentPhotoIdPublicId: myPhotoIdPublicId_s,
                                                ConsentSignature: mySignature_s,
                                                ConsentSignaturePublicId: mySignaturePublicId_s,
                                                ConsentGuardianName: userInput.consentGuardianName,
                                                ConsentGuardianRelation: userInput.consentGuardianRelation,
                                                ConsentGuardianSignature: myGuardianSignature_s,
                                                ConsentGuardianSignaturePublicId: myGuardianSignaturePublicId_s,
                                                ConsentClauses: userInput.consentClauses,
                                                ConsentNotes: userInput.consentNotes,
                                                ConsentFooter: userInput.consentFooter,
                                                ConsentFormName: userInput.consentFormName
                                            }),
                                        })
                                            .then(response => response.json())
                                            .then(data => {
                                            })
                                            .catch(error => console.error(error));
                                        this.successAlert(true);
                                    }
                                })
                                .catch(error => console.error(error));
                        }
                    })
                    .catch(error => console.error(error));
            }
        this.setState({submitButton: true});
        } else
            this.successAlert(false);
    }

    handleChange(e) {
        var myDoB = e._d;
        var myAge = this.getAge(myDoB);
        var parentConsentNeeded = false;
        var oldEnough = false;

        //Set some state objects so we can validate age and also build the form out dynamically for Parent Guardian
        //Name and Signature.
        switch(this.props.consentSubmission.AgeLimit) {
            case "No Age Limit":
                    oldEnough = true;
                    parentConsentNeeded = false;
                break;
            case "Under 16 needs Parent":
                if(myAge < 16)
                    oldEnough = parentConsentNeeded = true;
                else {
                    parentConsentNeeded = false;
                    oldEnough = true;
                }
                break;
            case "Under 18 needs Parent":
                if(myAge < 18)
                    oldEnough = parentConsentNeeded = true;
                else {
                    parentConsentNeeded = false;
                    oldEnough = true;
                }
                break;
            case "16 and over, no exceptions":
                if(myAge >= 16)
                    oldEnough = true;
                else
                    oldEnough = false;
                break;
            case "18 and over, no exceptions":
                if(myAge >= 18)
                    oldEnough = true;
                else
                    oldEnough = false;
                break;
            default:
        }

        this.setState({
            consentDoB: myDoB,
            consentAge: myAge,
            consentOldEnough: oldEnough,
            consentParentConsentNeeded: parentConsentNeeded,
            consentGuardianName: ""
        });
        //this.forceUpdate();

    }

    clearConsentSignature(event){
        event.preventDefault();
        this.sigCanvas.clear();
        this.setState({
            consentGuardianSignature: "",
        });
}

    clearGuardianConsentSignature(event){
        event.preventDefault();
        this.sigGuardianCanvas.clear();
        this.setState({
            consentGuardianSignature: "",
        });

    }

    takePicture() {
        this.camera.capture()
            .then(blob => {
                this.img.src = URL.createObjectURL(blob);
                this.img.onload = () => { URL.revokeObjectURL(this.src); }
            })
    }

    setRef = webcam => {
        this.webcam = webcam;
    };

    capture = () => {
        const imageSrc = this.webcam.getScreenshot();
        this.setState({
            consentPhotoId: imageSrc,
        });
    };



    /*
    handleChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        var myDoB = ReactDOM.findDOMNode(this.dob).value;
        var myAge = this.getAge(myDoB);
        debugger;
        this.setState({
            consentDoB: myDoB,
            consentAge: myAge
        });

    };*/

    getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    // Validates that the input string is a valid date formatted as "mm/dd/yyyy"
    isValidDate(dateString)
    {
        //Convert the dateString to a date, reformat a temp string from it to mm/dd/yyyy
        var d = new Date(dateString),
            month_s = '' + (d.getMonth() + 1),
            day_s = '' + d.getDate(),
            year_s = d.getFullYear();

        if (month_s.length < 2)
            month_s = '0' + month_s;
        if (day_s.length < 2)
            day_s = '0' + day_s;

        var date_s = [month_s, day_s, year_s].join('/');

        //debugger;
        // First check for the pattern
        if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date_s))
            return false;

        // Parse the date parts to integers
        var parts = date_s.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    };


  render() {
      const videoConstraints = {
          width: 1280,
          height: 720,
          //facingMode: "user"
          facingMode: "environment"
      };
    return (
      <div className="wizard-step">
          <Card
              content={
                  <div>
                      <legend>Personal Information <span
                          className="text-danger">*</span></legend>
                      <Row>
                          <Col md={10} mdOffset={1}>
                              <FormGroup>
                                  <ControlLabel><div>
                                      <h5>
                                          I hereby declare that I am of legal age (with valid proof of age) and I am
                                          competent to sign this Agreement or, if not, that my parent or legal guardian
                                          shall sign on my behalf, and that my parent or legal guardian is in complete
                                          understanding and concurrence with this agreement.
                                      </h5>
                                  </div>
                                  </ControlLabel>
                              </FormGroup>
                          </Col>
                      </Row>
                      <Row>
                          {this.props.consentSubmission.RequireName ?
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Name <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentName"
                                          type="text"
                                          name="name"
                                          placeholder="Your full name"
                                          onChange={event => this.setState({consentName: event.target.value})}
                                      />
                                      {this.state.consentNameError}
                                  </FormGroup>
                              </Col>
                              : <div></div>}
                      </Row>
                      <Row>
                          <Col md={5} mdOffset={2}>
                              <FormGroup>
                                  <ControlLabel>Date of Birth <span className="text-danger">*</span> </ControlLabel>
                                  <Datetime
                                      id="consentDoB"
                                      timeFormat={false}
                                      inputProps={{placeholder: "Enter your DoB as mm/dd/yyyy or pick it using the calendar!"}}
                                      value={this.state.consentDoB}
                                      onChange={this.handleChange}
                                      disabled={true}
                                      //onChange={value => this.setState({ consentDoB: value })}
                                  />
                                  {this.state.consentDoBError}
                              </FormGroup>
                          </Col>
                          {((this.isValidDate(this.state.consentDoB)) && (this.state.consentOldEnough)) ?
                              <Col md={3}>
                                  <FormGroup>
                                      <div>
                                          <h6>
                                              <span className="text-success">{this.state.consentAge} years old,
                                                  Age Restriction MET!</span>
                                          </h6>
                                      </div>
                                  </FormGroup>
                              </Col>
                              : <div></div>}
                          {((this.isValidDate(this.state.consentDoB)) && (!this.state.consentOldEnough)) ?
                              <Col md={3}>
                                  <FormGroup>
                                      <div>
                                          <h6>
                                              <span className="text-danger">{this.state.consentAge} years old,
                                                  Age Restriction NOT MET!</span>
                                          </h6>
                                      </div>
                                  </FormGroup>
                              </Col>
                              : <div></div>}
                          {((!this.isValidDate(this.state.consentDoB)) && (this.state.consentDoB !== "")) ?
                              <Col md={3}>
                                  <FormGroup>
                                      <div>
                                          <h6>
                                              <span className="text-danger">Invalid Date of Birth,
                                                  Age Restriction NOT MET!</span>
                                          </h6>
                                      </div>
                                  </FormGroup>
                              </Col>
                              : <div></div>}
                      </Row>
                      {this.props.consentSubmission.RequireAddress ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Address <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentAddress"
                                          type="text"
                                          name="name"
                                          placeholder="Your address"
                                          onChange={event => this.setState({consentAddress: event.target.value})}
                                      />
                                      {this.state.consentAddressError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      {this.props.consentSubmission.RequirePhone ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Phone <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentPhone"
                                          type="phone"
                                          name="phone"
                                          placeholder="Your phone number"
                                          onChange={event => this.setState({consentPhone: event.target.value})}
                                      />
                                      {this.state.consentPhoneError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      {this.props.consentSubmission.RequireEmail ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Email <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentEmail"
                                          type="email"
                                          name="email"
                                          placeholder="Your email address"
                                          onChange={event => this.setState({consentEmail: event.target.value})}
                                      />
                                      {this.state.consentEmailError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      {this.props.consentSubmission.RequireNationality ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Nationality <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentNationality"
                                          type="text"
                                          name="consent_nationality"
                                          placeholder="Your nationality"
                                          onChange={event => this.setState({consentNationality: event.target.value})}
                                      />
                                      {this.state.consentNationalityError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      {this.props.consentSubmission.RequireGender ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Gender <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentGender"
                                          type="text"
                                          name="gender"
                                          placeholder="Your Gender"
                                          onChange={event => this.setState({consentGender: event.target.value})}
                                      />
                                      {this.state.consentGenderError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      <Row>
                          <Col md={5} mdOffset={2}>
                              <FormGroup>
                                  <ControlLabel>Your Signature: <span className="text-danger">*</span></ControlLabel>
                                  <SignatureCanvas penColor='black'
                                                   canvasProps={{width: 500, height: 200, className: 'sigCanvas'}}
                                                   backgroundColor="rgba(255, 255, 255, 1)"
                                                   ref={(ref) => {
                                                       this.sigCanvas = ref
                                                   }}
                                  />
                                  {this.state.consentSignatureError}
                              </FormGroup>
                          </Col>
                      </Row>
                      <Row>
                          <Col md={3} mdOffset={1} xs={5} xsOffset={1}>
                              <Button bsStyle="info" pullRight fill wd onClick={this.clearConsentSignature}>
                                  Clear
                              </Button>
                          </Col>
                      </Row>
                  </div>
              }
              />
          { this.state.consentParentConsentNeeded  ?
          <Card
              content={
                  <div>
                      <legend>Parent /  Guardian Requirements <span
                          className="text-danger">*</span></legend>
                      <Row>
                          <Col md={12} mdOffset={1}>
                              <FormGroup>
                                  <ControlLabel><div>
                                      <h5>
                                          {this.props.consentSubmission.ParentHeader}
                                      </h5>
                                  </div></ControlLabel>
                              </FormGroup>
                          </Col>
                      </Row>
                      { this.state.consentParentConsentNeeded  ?
                        <Row>
                            <Col md={5} mdOffset={2}>
                                <FormGroup>
                                    <ControlLabel>Guardian Name <span className="text-danger">*</span></ControlLabel>
                                    <FormControl
                                        id="consentGuardianName"
                                        type="text"
                                        name="consent_guardian"
                                        placeholder="Your Guardian's Name"
                                        onChange={event => this.setState({consentGuardianName: event.target.value})}
                                    />
                                    {this.state.consentGuardianNameError}
                                </FormGroup>
                            </Col>
                        </Row>
                      : <div></div> }
                      { ((this.state.consentParentConsentNeeded) && (this.props.consentSubmission.AskRelation)) ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Your Relation to Parent / Guardian <span className="text-danger">*</span></ControlLabel>
                                      <FormControl
                                          id="consentGuardianRelation"
                                          type="text"
                                          name="consent_relation"
                                          placeholder="Your relation to your Parent / Guardian"
                                          onChange={event => this.setState({consentGuardianRelation: event.target.value})}
                                      />
                                      {this.state.consentGuardianRelationError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div> }
                      {this.state.consentParentConsentNeeded ?
                          <Row>
                              <Col md={5} mdOffset={2}>
                                  <FormGroup>
                                      <ControlLabel>Your Guardians Signature: <span
                                          className="text-danger">*</span></ControlLabel>
                                      <SignatureCanvas penColor='black'
                                                       canvasProps={{
                                                           width: 500,
                                                           height: 200,
                                                           className: 'sigGuardianCanvas'
                                                       }}
                                                       backgroundColor="rgba(255, 255, 255, 1)"
                                                       ref={(ref) => {
                                                           this.sigGuardianCanvas = ref
                                                       }}
                                      />
                                      {this.state.consentGuardianSignatureError}
                                  </FormGroup>
                              </Col>
                          </Row>
                          : <div></div>}
                      {this.state.consentParentConsentNeeded ?
                          <Row>
                              <Col md={3} mdOffset={2} xs={5} xsOffset={2}>
                                  <Button bsStyle="info" pullRight fill wd
                                          onClick={this.clearGuardianConsentSignature}>
                                      Clear
                                  </Button>
                              </Col>
                          </Row>
                          : <div></div>}
                  </div>
              }
                />
              : <div></div> }
          <Card
              content={
                  <div>
                      <legend>Take a photo of your Government Issued Photo ID: <span
                          className="text-danger">*</span></legend>
                      { /* react-camaera only works on pcs...not on ipads...
                      <Row>
                          <Col md={5} mdOffset={2}>
                          <FormGroup>
                                  <ControlLabel><div>
                                      <h5>Preview:</h5>
                                  </div>
                                  </ControlLabel>
                                  <div style={style.container}>
                                      <Camera
                                          style={style.preview}
                                          ref={(cam) => {
                                              this.camera = cam;
                                          }}
                                      >
                                          <div style={style.captureContainer} onClick={this.takePicture}>
                                              <div style={style.captureButton}/>
                                          </div>
                                      </Camera>
                                  </div>
                              </FormGroup>
                          </Col>
                      </Row>
                      <Row>
                          <Col md={5} mdOffset={2}>
                              <FormGroup>
                                  <ControlLabel><div>
                                      <h5>Current Photo:</h5>
                                  </div>
                                  </ControlLabel>
                                  <div style={style.container}>
                                  <img
                                      style={style.captureImage}
                                      ref={(img) => {
                                          this.img = img;
                                      }}
                                  />
                                  </div>
                            </FormGroup>
                          </Col>
                      </Row> */ }
                      { /* react-webcam works on ipads using the Safari, no worky on chrome or firefox */ }
                      <Row>
                          <Col md={5} mdOffset={2}>
                              <FormGroup>
                                  <div style={style.container}>
                                      <Webcam
                                          audio={false}
                                          height={400}
                                          ref={this.setRef}
                                          screenshotFormat="image/jpeg"
                                          width={400}
                                          videoConstraints={videoConstraints}
                                      />
                                      {this.state.consentPhotoIdError}
                                  </div>
                              </FormGroup>
                          </Col>
                      </Row>
                      <Row>
                          <Col md={5} mdOffset={2} xs={5} xsOffset={2}>
                              <Button bsStyle="info"  fill wd onClick={this.capture}>
                                  Capture
                              </Button>
                          </Col>
                      </Row>
                      <Row>
                          <Col md={5} mdOffset={2}>
                              <FormGroup>
                                  <ControlLabel><div>
                                      <h5>Current Photo:</h5>
                                  </div>
                                  </ControlLabel>
                                  { this.state.consentPhotoId !== "" ?
                                  <div style={style.container}>
                                      <img
                                          style={style.captureImage}
                                          src={this.state.consentPhotoId}
                                      />
                                  </div>
                                      : <div></div> }
                              </FormGroup>
                          </Col>
                      </Row>
                      <Row>
                          <Col md={7} mdOffset={1} >
                              <FormGroup controlId="formControlsTextarea">
                                  <ControlLabel>Additional Health Department Notes </ControlLabel>
                                  <FormControl
                                      id="consentNotes"
                                      rows="5"
                                      name="consent_Notes"
                                      componentClass="textarea"
                                      placeholder="Any misc or additional notes..."
                                      bsClass="form-control"
                                      value={this.state.consentNotes}
                                      onChange={event => this.setState({consentNotes: event.target.value})}
                                  />
                                  {this.state.consentNotesError}
                              </FormGroup>
                          </Col>
                      </Row>
                  </div>
              }
          />
          <Row>
              <Col md={10} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel><div>
                          <h5>
                              {this.props.consentSubmission.ConsentFooter}
                          </h5>
                      </div>
                      </ControlLabel>
                  </FormGroup>
              </Col>
          </Row>
      <div className="wizard-finish-button">
          <Button
              id="submit"
              disabled={this.state.submitButton}
              bsStyle="info"
              fill
              wd
              pullRight
              onClick={this.saveConsentSubmission}
          >
              Submit
          </Button>
      </div>
          {this.state.alert}
      </div>

    );
  }
}

const style = {
    preview: {
        position: 'relative',
    },
    captureContainer: {
        display: 'flex',
        position: 'absolute',
        justifyContent: 'center',
        zIndex: 1,
        bottom: 0,
        width: '50%'
    },
    captureButton: {
        backgroundColor: '#fff',
        borderRadius: '50%',
        height: 56,
        width: 56,
        color: '#000',
        margin: 20
    },
    captureImage: {
        width: '50%',
    }
};


export default Personal_Step3;



// WEBPACK FOOTER //
// ./src/views/Forms/DisplayConsentFormWizard/Personal_Step3.jsx